<template>
  <div class="nx-scrollytelling-slide-multimedia-list">
    <nx-relation-editor-toolbar title="Listado de imágenes">
      <template slot="actions">
        <v-tooltip class="button-add" top>
          <v-btn icon small @click="create" slot="activator">
            <v-icon>add</v-icon>
          </v-btn>
          <span>{{ $t('message.relation.add') }}></span>
        </v-tooltip>
      </template>
    </nx-relation-editor-toolbar>
    <div ref="list" class="mt-3" :class="{ moving }">
      <nx-scrollytelling-slide-multimedia-list-item v-for="(item, index) in value"
                                                    :class="{ 'mt-1': index > 0 }"
                                                    :key="item.uuid"
                                                    :name="item.imageAlt"
                                                    :image="item.desktopImage"
                                                    @click="handleEdit(item)">
        <template slot="actions">
          <v-btn icon @click.prevent.stop="handleDelete(item)"><v-icon color="primary">delete</v-icon></v-btn>
        </template>
      </nx-scrollytelling-slide-multimedia-list-item>
    </div>
    <nx-relation-empty-card v-if="isEmpty"
                            :show-icon="false"
                            text="message.content.editor.scrollytelling.emptyList"/>

    <nx-scrollytelling-slide-multimedia-editor :active="activeDialog"
                                               @dismiss="dismiss"
                                               @input="commitMultimedia"
                                               :include-rich-text="includeRichText"
                                               :value="currentMultimedia">
      <slot></slot>
    </nx-scrollytelling-slide-multimedia-editor>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import uuid from 'uuid/v4';
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar';
import NxScrollytellingSlideMultimediaListItem
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideMultimediaListItem';
import NxRelationEmptyCard from '@/modules/relation/card/EmptyCard';
import NxScrollytellingSlideMultimediaEditor
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideMultimediaEditor';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'nx-scrollytelling-slide-multimedia-list',
  inject: ['$parentForm'],
  components: {
    NxScrollytellingSlideMultimediaEditor,
    NxRelationEmptyCard,
    NxScrollytellingSlideMultimediaListItem,
    NxRelationEditorToolbar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    includeRichText: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeDialog: false,
      currentMultimedia: undefined,
      moving: false,
    };
  },
  computed: {
    isEmpty() {
      return this.value.length === 0;
    },
  },
  methods: {
    create() {
      this.activeDialog = true;
    },
    move(from, to) {
      const items = cloneDeep(this.value);
      items.splice(to, 0, items.splice(from, 1)[0]);
      this.$parentForm.updateField(this.name, items);
    },
    handleEdit(item) {
      this.currentMultimedia = item;
      this.$nextTick(() => {
        this.activeDialog = true;
      });
    },
    handleDelete(item) {
      const items = this.value.filter(element => item.uuid !== element.uuid);
      this.$parentForm.updateField(this.name, items);
    },
    commitMultimedia(multimedia) {
      const items = cloneDeep(this.value);
      let item = items.find(element => multimedia.uuid === element.uuid);
      if (!item) {
        items.push({ uuid: uuid(), ...multimedia });
      } else {
        const itemIndex = items.findIndex(element => multimedia.uuid === element.uuid);
        item = { ...item, ...multimedia };
        items[itemIndex] = item;
      }
      this.$parentForm.updateField(this.name, items);
      this.dismiss();
    },
    dismiss() {
      this.activeDialog = false;
      this.$nextTick(() => {
        this.currentMultimedia = undefined;
      });
    },
  },
  mounted() {
    this.sortablejs = Sortable.create(this.$refs.list, {
      handle: '.nx-drag-handle',
      onUpdate: ({
        oldIndex,
        newIndex,
      }) => this.move(oldIndex, newIndex),
      onStart: () => {
        this.moving = true;
      },
      onEnd: () => {
        this.moving = false;
      },
    });
  },
};
</script>

<style lang="stylus" scoped>
.nx-scrollytelling-slide-multimedia-list {
  &.moving {
    *:not(.sortable-chosen) {
      opacity: .7;
    }
  }

  .button-add {
    margin-right: 12px;
  }
}
</style>
